export const MOBILE_IMAGE_SRC = 'https://{src}/m/288x80';
export const DESKTOP_IMAGE_SRC = 'https://{src}/m/0x400';
